import axios from './configAxiosClient';

export const putClient = async (clientId, requestData) => {
  return axios.put(`/${clientId}/update/`, requestData);
};